/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import { downloadCollectionBulkResult, collectionBulkCancel, CollectionBulkPolling, DeleteCollectionLogs, getCollectionImportHistory, getShopUrl, collectionExportStatus, checkPrevExportExist, MainAuthUrl, getExportConfig, getTrialStatus } from '../Services/CommonServices';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { CollectionRuleConditionsModal } from '../common/CollectionRuleConditionsModal';
import { errorMetaModal, errorModal } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import { useNavigate } from 'react-router-dom';
import WatermarkImage from '../../assets/3129492.jpg';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function Collections({ blockUpload, eventSource, appUpdate }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [file, setFile] = useState();
    const [logsLoading, setLogsLoading] = useState(false);

    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv', '.CSV', 'text/csv', '.xlsx', '.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0]);
            setRejectedFiles(_rejectedFiles[0]);
        },
        [],
    );
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [appUpdateLoader, setAppUpdateLoader] = useState(false);
    const [mutationType, setMutationType] = useState('');
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});

    // Trial authorization state
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);
    const [ChargeUrl, setChargeUrl] = useState("");

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    // Memoized UI Components
    const fileUpload = useMemo(() => 
            !file && <s-text>Click here to upload a file</s-text>
        , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" align="center">
                <s-thumbnail
                    size="small"
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : "note"
                    }
                />
                <div>
                    <s-text>
                        {file.name}
                    </s-text>
                    <s-text as="p">
                        {file.size} bytes
                    </s-text>
                </div>
            </s-stack>
        )
    , [file, validFileTypes]);

    var appUpdateBanner = (
        <s-banner heading="Update Required" tone="info">
            Updates are required due to changes in Shopify API. The following scopes are needed:
            <s-unordered-list>
                <s-list-item>read_publications</s-list-item>
                <s-list-item>write_publications</s-list-item>
            </s-unordered-list>
            <s-button
                slot="secondary-actions"
                variant="secondary"
                onClick={() => { redirectToAppUpdate() }}
                loading={appUpdateLoader}
            >
                Update now
            </s-button>
        </s-banner>
    );

    const [vendorArray, setVendorArray] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState();
    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [ruleConditionsModalActive, setRuleConditionsModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [collectionProcessingStep, setCollectionProcessingStep] = useState();
    const [collectionDeleteStatus, setCollectionDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitCollections, setSplitCollections] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [collectionBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [retryCount, setRetryCount] = useState(0);
    const SSE_RETRY_DELAY = 5000;

    useEffect(() => {
        getConfigExport();
        setFile(null);
        deleteOlderLogs();
        statusPolling();
        getLogs();
        checkExportStatus();
        loadTrialStatus(); // Load trial status on mount
    }, []);

    // Trial authorization helper functions
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true;
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };

    useEffect(() => {
        console.log("[Collections SSE] EventSource object:", eventSource);
        console.log("[Collections SSE] EventSource readyState:", eventSource?.readyState, 
                    "(0=CONNECTING, 1=OPEN, 2=CLOSED)");
        
        if (eventSource) {
            console.log("[Collections SSE] Setting up message handler");
            eventSource.onmessage = (event) => {
                const data = event.data;
                console.log("[Collections SSE] Received event data:", data);
                
                // Try to parse as JSON to check for new SSE event format
                let messageData = null;
                let eventType = null;
                try {
                    const parsedData = JSON.parse(data);
                    eventType = parsedData.type;
                    messageData = parsedData;
                    console.log("[Collections SSE] Parsed event type:", eventType);
                } catch (e) {
                    // Not JSON, keep using legacy string-based detection
                    console.log("[Collections SSE] Legacy event format detected");
                }
                
                // Handle new validation error format
                if (eventType === "validationError") {
                    console.log("[Collections SSE] Validation error received:", messageData);
                    const { message: errorType, details: errors } = messageData || {};
                    setFile(null);
                    setBulkStatus(""); // Reset bulk status to hide processing message
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setProcessingMsg(""); // Clear processing message
                    setUploadErrors({ 
                        validation: false, 
                        errorType: errorType || "Validation Error", 
                        errors: errors || [] 
                    });
                }
                // Legacy format handling
                else if (data.includes("collectionValidation")) {
                    const { collectionValidation } = JSON.parse(data);

                    if (collectionValidation === true) {
                        setUploadBtnLoading(false);
                        setIsUploadError(false);
                        setBulkStatus("processing");
                        setProcessingMsg("calculating items");
                        setFile(null);
                    } else {
                        setFile(null);
                        setBulkStatus(""); // Reset bulk status to hide processing message
                        setUploadStatus(false);
                        setPollingResult(undefined);
                        setUploadBtnLoading(false);
                        setIsUploadError(true);
                        setErrModalActive(true);
                        setProcessingMsg(""); // Clear processing message
                        setUploadErrors(JSON.parse(data));
                    }
                } else if (data.includes("collectionuploading")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("uploading");
                    setStagedUploadProgress(JSON.parse(data));
                } else if (data.includes("Collection delete")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("Collection delete");
                    setCollectionDeleteStatus(JSON.parse(data));
                } else if (data.includes("CollectionMetafield delete")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("Metafield delete");
                    setMetaDeleteStatus(JSON.parse(data));
                } else if (data.includes("bulkId")) {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject) {
                        const { status } = jsonObject;

                        if (status.toLowerCase() === "completed") {
                            setPollingResult(jsonObject);
                            setBulkStatus(status);
                            setUploadStatus(false);
                            getLogs();
                        } else if (status.toLowerCase() === "canceled") {
                            setUploadStatus(false);
                            setBulkStatus(status);
                            getLogs();
                        } else {
                            setUploadStatus(true);
                            setBulkStatus(status);
                            setPollingResult(jsonObject);
                        }
                    }
                } else if (data.includes("CollectionProcessingStep")) {
                    const jsonObject = JSON.parse(data);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setProcessingMsg("CollectionProcessingStep");
                    setCollectionProcessingStep(jsonObject);
                } else if (data.includes("CollectionCatalog extract")) {
                    const jsonObject = JSON.parse(data);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setCatalogExtractMsg(jsonObject);
                    setProcessingMsg("Catalog extract");
                } else if (data.includes("Split collections")) {
                    const jsonObject = JSON.parse(data);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setProcessingMsg("Split collections");
                    setSplitCollections(jsonObject);
                }
                else if (data.includes("bulkop")) {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject.status = "canceled") {
                        setBulkStatus(false);
                        setPollingResult(undefined);
                        setBulkCancelStatus(""); getLogs();
                    }
                    else {
                        setBulkCancelStatus(jsonObject.status);
                    }
                } else if (data === "pong") {
                } else if (data === "collectionDownloadComplete") {
                    setDownloadSpinner(false);
                }
                else if (data.includes("collectionfailed")) {
                    console.log("[Collections SSE] Collection export failed");
                    setExportStatus("failed");
                    setDownloadSpinner(false);
                }

                else if (data.includes("collectionExportCompleted")) {
                    console.log("[Collections SSE] Collection export completed");
                    setDownloadSpinner(false);
                    setExportBtnLoading(false);
                    getConfigExport();
                }
                else if (data.includes("Export")) {
                    console.log("[Collections SSE] Export event received:", data);
                    if (exportConfig === null && !isExportConfig) {
                        isExportConfig = true;
                        getConfigExport();
                    }
                    const jsonObject = JSON.parse(data);
                    console.log("[Collections SSE] Parsed export object:", jsonObject);
                    if (jsonObject) {
                        const { type, status, completedAt } = jsonObject;
                        console.log("[Collections SSE] Export type:", type, "status:", status);
                        if (type.includes("Product")) { setMutationType("product"); }
                        else if (type.includes("Collection")) {
                            console.log("[Collections SSE] Processing Collection export");
                            setMutationType("collection"); setExportResult(jsonObject);
                            if (status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired") {
                                setDownloadSpinner(false);
                                setExportBtnLoading(false);
                                if (type.includes("Customer")) {
                                    setExportStatus(status.toLowerCase());
                                    setExportCompletedAt(completedAt);
                                }
                                if (type === "CollectionExport") {
                                    setExportResult(jsonObject);
                                    setDownloadSpinner(false);
                                    setExportBtnLoading(false);
                                    // window.location.href = endpoint + '/api/Collection/download-previous-export?storeUrl=' + storeUrl;
                                }
                            }

                        }
                        setExportStatus(status.toLowerCase());

                    }
                }

            }
        }

        return () => {
            console.log("[Collections SSE] Cleaning up event listener");
            if (eventSource) {
                eventSource.onmessage = null; // Remove the event handler
            }
        };
    }, [eventSource]);


    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );



    const bulkResponseErrorModal = (
        <s-modal
            id="bulk-error-modal"
            size="base"
            heading="Failed collections"
            padding="none"
        >
            <s-table padding="none">
                <s-table-header-row>
                    <s-table-header>Sl No</s-table-header>
                    <s-table-header>Handle</s-table-header>
                    <s-table-header>Error</s-table-header>
                </s-table-header-row>
                <s-table-body>
                    {bulkErrors?.map(({ handle, userErrors }, index) => (
                        <s-table-row key={index}>
                            <s-table-cell>
                                <s-text type="strong">{index + 1}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>{handle}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text tone="critical">
                                    {userErrors?.[0]?.message || 'Unknown error'}
                                </s-text>
                            </s-table-cell>
                        </s-table-row>
                    ))}
                </s-table-body>
            </s-table>
            
            <s-button 
                slot="primary-action"
                commandFor="bulk-error-modal"
                command="--hide"
                onClick={handleBulkErrorChangeModal}
            >
                Close
            </s-button>
        </s-modal>
    );



    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function generateCollectionErrorModal(errors) {
        setBulkErrors(errors);
        setBulkErrorActive(true);
        
        // Open the modal using command after state update
        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateMetafieldErrorModal(errors) {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true)
    }

    // var exportStatusBanner = (
    //     <Banner
    //         title={exportStatus === "completed" ? "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed" : "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus}
    //         action={{
    //             disabled:exportStatus === "failed" || exportStatus === "running" ? true : false,
    //             content: 'Download Exported File', loading: downloadSpinner,  onAction: () => {
    //                 setDownloadSpinner(true);
    //                 try {
    //                     window.location.href = endpoint + '/api/Collection/download-previous-export?storeUrl=' + storeUrl;
    //                   } catch (error) {
    //                     setExportStatus("failed")
    //                     setExportLoading(false)
    //                   } 
    //             },
    //         }}
    //         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //         onDismiss={() => setExportStatus("")}>
    //             {exportStatus === "running" ? <p>This may take a few moments.</p> : null}
    //     </Banner>
    // );

    const [exportCompletedAt, setExportCompletedAt] = useState('');
    const [exportModalActive, setExportModalActive] = useState(false);
    // const exportModal = (
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: exportAllCollections,
    //                 disabled: exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={exportModalActive}
    //             title="Export"
    //             onClose={() => {setExportModalActive(false)}}>
    //                 <Modal.Section>
    //                     <Banner
    //                         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //                         onDismiss={false}>
    //                         <Text>
    //                             {exportStatus === "completed" ?
    //                                 "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
    //                                 : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed" ? ". This may take a few moments." : ".")}
    //                             {exportStatus === "completed" && !downloadSpinner? <Link url="" onClick={() => {
    //                                 setDownloadSpinner(true);
    //                                 window.location.href = endpoint + '/api/Collection/download-previous-export?storeUrl=' + storeUrl;
    //                             }}>Download</Link> : downloadSpinner ? <Spinner  size="small"/> : null}
    //                         </Text>
    //                     </Banner>
    //                 </Modal.Section>

    //         </Modal>
    //     </>
    // );
    return (
        <s-page heading='Collections'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                onClick={() => { exportAllCollections() }}
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>
            { showTrialBanner ? <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            /> : null }
            {appUpdate ? appUpdateBanner : null}
            <s-stack gap="base">
                <s-section padding="base">
                    <s-box padding="none">
                        <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                            <s-grid-item gridColumn="span 6">
                                <s-stack gap="small">
                                    {/* DropZone Section */}
                                    <s-stack gap="small-100">
                                        <s-heading>Upload File</s-heading>
                                        <s-link onClick={() => openSampleFile()}>
                                            Download a sample file
                                        </s-link>
                                        
                                        <s-drop-zone
                                            multiple={false}
                                            accept=".csv,.xlsx"
                                            onInput={(event) => {
                                                const files = event.currentTarget.files;
                                                if (files && files.length > 0) {
                                                    handleDropZoneDrop([], Array.from(files), []);
                                                }
                                            }}
                                        >
                                            {uploadedFile}
                                            {fileUpload}
                                        </s-drop-zone>
                                        
                                        <s-text color="subdued">
                                            Accepts .csv/.xlsx format. Maximum size: 20 MB
                                        </s-text>
                                    </s-stack>

                                    {/* Action Buttons Section */}
                                    <s-stack gap="small-100">
                                        <s-stack direction="inline" gap="small">
                                            <s-button
                                                variant="primary"
                                                disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                                loading={uploadBtnLoading}
                                                onClick={() => FileUploadValidation()}
                                            >
                                                Upload
                                            </s-button>
                                            {/* <s-button 
                                                variant="secondary" 
                                                onClick={() => openSampleFile()}
                                            >
                                                Download sample
                                            </s-button> */}
                                        </s-stack>
                                        
                                        {hasError && (
                                            <s-text as="p" tone="critical">
                                                {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                            </s-text>
                                        )}
                                    </s-stack>
                                </s-stack>
                            </s-grid-item>
                            
                            <s-grid-item gridColumn="span 6">
                                <div style={{ position: 'relative' }}>
                                    <div 
                                        style={{
                                            position: 'absolute',
                                            bottom: '-65px',
                                            right: '10px',
                                            width: '300px',
                                            height: '300px',
                                            backgroundImage: `url(${WatermarkImage})`,
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'bottom right',
                                            opacity: '0.15',
                                            pointerEvents: 'none',
                                            zIndex: 0
                                        }}
                                    />
                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                        <s-stack gap="small-100">
                                            <s-heading>Note</s-heading>
                                            <s-unordered-list>
                                                <s-list-item>
                                                    Metafields are separate column headers with the format: <s-text type="strong">collection/namespace/metafield-name/type</s-text>
                                                </s-list-item>
                                                <s-list-item>
                                                    To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                                </s-list-item>
                                                <s-list-item>
                                                    Image urls in metafields can be comma(,) separated in the first row of the collection.
                                                </s-list-item>
                                                <s-list-item>
                                                    Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in Shopify
                                                </s-list-item>
                                                <s-list-item>
                                                    The app supports bulk operations for collections and their metafields efficiently
                                                </s-list-item>
                                            </s-unordered-list>
                                        </s-stack>
                                    </div>
                                </div>
                            </s-grid-item>
                        </s-grid>
                    </s-box>
                </s-section>
            </s-stack>

            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                collectionProcessingStep={collectionProcessingStep}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitCollections}
                productDeleteStatus={collectionDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                productBulkCancelStatus={collectionBulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateCollectionErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
            />

            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" ?
                // <>
                // {bulkStatus.toLocaleLowerCase() === "completed" || bulkStatus.toLocaleLowerCase() === "failed" ? <br /> : null}
                    <ExportStatusCard exportResult={exportResult} progress={0} exportConfig={exportConfig} currentRoute="collection" />
                // </>
                 : null}

             <s-box paddingBlockStart= "base">
                <s-section padding="none">
                    <ImportHistory
                        logs={logs}
                        generateProductErrorModal={generateCollectionErrorModal}
                        generateMetafieldErrorModal={generateMetafieldErrorModal}
                        downloadResult={downloadResult}
                        loadingMap={loadingMap}
                        logsLoading={logsLoading}
                    />
                    
                    {logs.length !== 0 && (
                        <s-stack direction="inline" align="center">
                            <s-pagination
                                has-previous={prvButton}
                                onPrevious={() => prev()}
                                has-next={nxtButton}
                                onNext={() => next()}
                            />
                        </s-stack>
                    )}
            </s-section>
            </s-box>
            
            {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}
            {/* {exportModal} */}
            {bulkErrors.length > 0 ? bulkResponseErrorModal : null}
            {isUploadError && uploadErrors?.errors?.length > 0 ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
                onViewRuleConditions={() => setRuleConditionsModalActive(true)}
            /> : null}
            {ruleConditionsModalActive && (
                <CollectionRuleConditionsModal 
                    isOpen={ruleConditionsModalActive}
                    onClose={() => setRuleConditionsModalActive(false)}
                />
            )}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />

            {/* {resultDownloadErrorToast} */}

        </s-page>
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadCollectionBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.collectionSampleFile, '_blank');
    }

    async function cancelBulk(bulkId) {
        collectionBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }



    function FileUploadValidation() {
        // Check trial access first
        if (!checkTrialAccess()) {
            return;
        }

        if (file !== null) {
            setUploadStatus(true);
            setPollingResult(undefined);
            setBulkStatus("validating")
            setProcessingMsg("validating");
            setIsUploadError(false);
            setUploadErrors(false);
            setBulkErrors([]);
            setUploadBtnLoading(true);
            const formData = new FormData();
            formData.append("file", file);
            const requestOptions = {
                method: 'POST',
                body: formData
            };
            fetch(endpoint + '/api/Collection/file-validation?storeUrl=' + storeUrl, requestOptions)
            setFile(null);
        }
    }


    function deleteOlderLogs() {
        DeleteCollectionLogs(storeUrl).then(function (result) {
        });
    }


    function exportAllCollections() {
        // Check trial access first
        if (!checkTrialAccess()) {
            return;
        }
        
        // Set initial export state
        setExportStatus('running');
        setExportBtnLoading(true);
        
        // Initialize export result with running status
        setExportResult({
            type: 'CollectionExport',
            status: 'RUNNING',
            createdAt: new Date().toISOString(),
            completedAt: null,
            rootObjectCount: 0
        });
        
        // Initialize export config with running status if it's null
        if (exportConfig === null) {
            setExportConfig({
                status: 'running',
                createdAt: new Date().toISOString(),
                fileUrl: null
            });
        }
        
        // setDownloadSpinner(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(endpoint + '/api/Collection/export-collection?storeUrl=' + storeUrl, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    return response.statusText
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                return []
            })
    }


    function statusPolling() {
        CollectionBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        collectionExportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && type === "collection") {
                    // setMutationType(type);
                    setExportStatus(status)
                    setExportCompletedAt(result.completedAt);
                    setExportResult(result);
                    setRootObjectCount(result.completedCount);
                    setDownloadSpinner(false);
                }
                else if (type === "collection" && status === "running") {
                    // setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setRootObjectCount(result.completedCount);
                    setDownloadSpinner(true);
                }
                else if (type === "collection" && status === "processing") {
                    // setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (status === "failed" && type === "collection") {
                    setDownloadSpinner(false);
                    // setMutationType(type);
                    setExportResult(result);
                    setExportStatus("failed")

                }

                else if (status === "failed" && type === "product") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                }
                else if (type !== "collection" && status === "running") {
                    // setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }

                else {
                    // setMutationType(type);
                    setDownloadSpinner(false);
                }
            }
            else {
                setDownloadSpinner(false);
            }
        })
    }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getCollectionImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount(Math.ceil(result.totalCount / pageSize));
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }

    function checkPrevExport() {
        checkPrevExportExist(storeUrl, "Collection").then(function (result) {
            if (result !== null) {
                if (result.exists) {
                    setExportCompletedAt(result.lastModified);
                    setExportStatus("completed");
                }
                else {
                    setExportStatus("");
                    setMutationType("collection");
                }
            }
        });
    }

    function redirectToAppUpdate() {
        setAppUpdateLoader(true);
        MainAuthUrl(storeUrl)
            .then(res => {
                window.open(res, '_top');
            }, err => {
            });
    }

    function getConfigExport() {
        getExportConfig(storeUrl, "collection").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
            }
        });
    }
}

